import model from 'api'
import * as types from 'mutation-types'
import { setSessionStorage } from 'utils/storage'

const state = {
  list: [],
  total: 0,
  pageCount: 0,
  params: {
    pageNo: 1,
    pageSize: 10
  },
  current: {},

  commandDialog: false,
  configDialog: false,
  strategyDialog: false,

  loadingList: false
}

const getters = {}

const mutations = {
  [types.GATEWAY_SET_LIST] (state, { list, total, pageCount }) {
    state.list = list
    state.total = total
    state.pageCount = pageCount
  },
  [types.GATEWAY_SET_LOADING_LIST] (state, loading) {
    state.loadingList = loading
  },
  [types.GATEWAY_TOGGLE_COMMON_DIALOG] (state, { current, visible }) {
    state.current = current
    state.commandDialog = visible
  },
  [types.GATEWAY_TOGGLE_CONFIG_DIALOG] (state, { current, visible }) {
    state.current = current
    state.configDialog = visible
  },
  [types.GATEWAY_TOGGLE_STRATEGY_DIALOG] (state, { current, visible }) {
    state.current = current
    state.strategyDialog = visible
  },
  [types.GATEWAY_SET_PARAMS] (state, data) {
    // state.params = Object.assign(state.params, data)
    if (data.snHex !== undefined) {
      state.params = {
        pageNo: data.pageNo,
        pageSize: 10,
        snHex: data.snHex
      }
    } else {
      state.params = {
        pageNo: data.pageNo,
        pageSize: 10
      }
    }
  }
}

const actions = {
  async getList ({ commit, state }) {
    try {
      commit(types.GATEWAY_SET_LOADING_LIST, true)
      const { list, total, pageCount } = await model.Gateway.getList(state.params)
      commit(types.GATEWAY_SET_LIST, { list, total, pageCount })
    } catch (e) {
      commit(types.GATEWAY_SET_LIST, { list: [], total: 0, pageCount: 0 })
    } finally {
      setSessionStorage('gateway_list_params', state.params)
      commit(types.GATEWAY_SET_LOADING_LIST, false)
    }
  },
  async setParams ({ commit, dispatch }, data) {
    commit(types.GATEWAY_SET_PARAMS, data)
    await dispatch('getList')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
